import React from 'react';
import { useIntl } from 'react-intl';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import WorkspaceCardItemRequestedStatus from './WorkspaceCardItemRequestedStatus';
import WorkspaceTools from './WorkspaceTools';
import workspaceConditionsMarkdown from '../helper';

const WorkspaceCardItem = ({
  hasConditions,
  onCheckBoxClick,
  single,
  upward,
  workspace,
}) => {
  const intl = useIntl();
  return (
    <CardItem className="aridhia-workspace-card-item" warning={workspace.requested}>
      <NameDescriptionCard
        description={hasConditions ? workspaceConditionsMarkdown(workspace.compatibility, intl) : undefined}
        entity={workspace.requested ? 'workspace.requested' : 'workspace'}
        markdown
        meta={workspace.location}
        name={workspace.reference || workspace.name}
        onSelect={onCheckBoxClick ? () => onCheckBoxClick(workspace.uuid) : undefined}
        selected={workspace.selected}
        single={single}
      >
        <WorkspaceTools upward={upward} workspace={workspace} />
      </NameDescriptionCard>
      <WorkspaceCardItemRequestedStatus workspace={workspace} />
    </CardItem>
  );
};

export default WorkspaceCardItem;
